import React from 'react';
import { motion } from 'framer-motion';
import { User } from 'lucide-react';
const testimonials = [{
  quote: 'Коли всі казали, що нічого не вдасться зробити, адвокат зміг оскаржити незаконне рішення ТЦК. Справу вирішено на мою користь, професіонал своєї справи!',
  author: 'Андрій М.',
  role: 'Військовослужбовець'
}, {
  quote: 'Дякую за швидку реакцію та якісну роботу. Вдалося грамотно оформити та отримати відстрочку від мобілізації завдяки його глибокому знанню законодавства.',
  author: 'Олександр К.',
  role: 'Призовник'
}, {
  quote: 'Звернувся щодо оскарження висновку ВЛК. Адвокат оперативно втрутився, допоміг правильно зібрати всі медичні документи та довести реальний стан здоров\'я.',
  author: 'Віталій С.',
  role: 'Ветеран / Клієнт'
}];
export function Testimonials() {
  return <section id="testimonials" className="py-24 bg-surface" data-id="element-149" data-mp="v7c8jc02nfs1">
      <div className="max-w-7xl mx-auto px-6" data-id="element-150" data-mp="qbeujcca6lif">
        <div className="text-center mb-16" data-id="element-151" data-mp="q8ixdq89c0v1">
          <h2 className="text-3xl md:text-4xl font-semibold mb-4" data-id="element-152" data-mp="h4wui1ce4aho">
            Відгуки клієнтів
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-7xl mx-auto" data-id="element-153" data-mp="m6m5jgzm4o5r">
          {testimonials.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-background p-8 rounded-3xl border border-border flex flex-col" data-id="element-154" data-mp="c6vcljqpah7s" data-mpi={index}>
              <p className="text-lg text-primary leading-relaxed mb-8 flex-grow" data-id="element-155" data-mp="v3d4c15juh41">
                "{item.quote}"
              </p>
              <div className="flex items-center gap-4" data-id="element-156" data-mp="1nma96mezz72d">
                <div className="w-10 h-10 rounded-full bg-surface flex items-center justify-center text-secondary" data-id="element-157" data-mp="1no3dvw61vh7q">
                  <User size={18} data-id="element-158" data-mp="1siwe4jmhby8b" />
                </div>
                <div data-id="element-159" data-mp="1sjflj6ei7483">
                  <div className="font-medium text-sm text-primary" data-id="element-160" data-mp="1sgtjfmadtgx9">
                    {item.author}
                  </div>
                  <div className="text-xs text-secondary" data-id="element-161" data-mp="1jihq3ci4s514">{item.role}</div>
                </div>
              </div>
            </motion.div>)}
        </div>
      </div>
    </section>;
}